export const CDN_URL =
  "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";
export const LOGO_URL =
  "https://img.freepik.com/free-vector/restaurant-tasty-food-logo-design_460848-10307.jpg?w=740&t=st=1712921460~exp=1712922060~hmac=bf52c746989c6d56056cf0fc62c39d67e0d14fcdad4b46a95202f873b242b984";

export const MENU_URL =
  "https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=19.0759837&lng=72.8776559&restaurantId=";
export const CONTAINER_DATA =
  "https://www.swiggy.com/dapi/restaurants/list/v5?lat=19.0759837&lng=72.8776559&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING";
